import Div from 'src/components/atomic/atom/Div'
import Svg from 'src/components/atomic/atom/Svg'
import Span from 'src/components/atomic/atom/Span'
import { COLOR } from 'src/constants/colors'
import Image from 'src/components/atomic/atom/Image'
import useMediaQueryHook from 'src/hooks/useMediaQuery.hook'
import { RootState } from 'src/store/store'
import { commonUtils } from 'src/utils/common.utils'
import {
  resetSelectPin,
  setImageDetailFlag,
  setSelectImage,
  setSelectPin,
} from 'src/store/Reducer/page/locationPageSlice'
import { useAppDispatch } from 'src/hooks/redux/useAppDispatch'
import { useAppSelector } from 'src/hooks/redux/useAppSelector'
import { SvgType } from 'src/types/types'
import { useTranslation } from 'react-i18next'
import NumberMarker from 'src/components/atomic/atom/NumberMarker'
import NowMarker from 'src/components/atomic/atom/NowMarker'
import React, { forwardRef } from 'react'
import useMatchHook from 'src/hooks/useMatch.hook'
import useDynamicWindowWidthHook from 'src/hooks/useDynamicWindowWidth.hook'

const LocationDetailModal = forwardRef((_props?: any, ref?: React.Ref<HTMLDivElement>) => {
  const { t } = useTranslation()
  const { setMediaStyle, currentMedia } = useMediaQueryHook()
  const dispatch = useAppDispatch()
  const { m_location_detail, m_location } = useMatchHook()
  const { selectPin } = useAppSelector((state: RootState) => state.LocationPage)
  const { Address } = useAppSelector((state: RootState) => state.currentLocation)
  const { setDateFormat } = commonUtils
  const isCurrent = selectPin?.Idx === -1
  const { windowWidth } = useDynamicWindowWidthHook()
  const locationTypeText: { [key: number]: { text: string; svgName: SvgType } } = {
    0: { text: `${t('LOCATE.HISTORY.LOCK_FIRST_TIME')}`, svgName: 'location_first_lock' },
    1: { text: `${t('LOCATE.HISTORY.DEVICE_LOCATED')}`, svgName: 'location_device_lock' },
    2: { text: `${t('LOCATE.HISTORY.TURN_OFF')}`, svgName: 'location_turn_off_attempt' },
  }

  const LocationDetailModalWrapStyle = {
    zIndex: 9997,
    width: 'auto',
    height: '100%',
    position: 'absolute',
    top: 0,
    display: m_location_detail || m_location ? 'flex' : 'none',
    justifyContent: 'center',
    alignItems: 'center',
  }

  const LocationDetailModalBoxStyle = {
    display: 'block',
    position: 'fixed',
    minHeight: isCurrent
      ? setMediaStyle('204px', '138px', '115px')
      : setMediaStyle('386px', '397px', '300px'),
    backgroundColor: 'white',
    width: setMediaStyle('400px', '600px', '100%'),
    maxWidth: setMediaStyle('400px', 'unset', 'unset'),
    left: setMediaStyle('572px', 'unset', '50%'),
    right: setMediaStyle('unset', '50%', 'unset'),
    bottom: setMediaStyle('28px', '0', '0'),
    transform: setMediaStyle('0', 'translate(50%, 0)', 'translate(-50%, 0)'),
    padding: setMediaStyle('24px', '16px 20px', '16px 20px'),
    margin: setMediaStyle('0', '0 auto', '0 auto'),
    borderRadius: setMediaStyle('16px', '16px 16px 0 0', '16px 16px 0 0'),
    textAlign: 'center',
  }

  const LocationDetailComponent = () => {
    return (
      <>
        {selectPin && (
          <>
            <Div
              display={currentMedia === 'pc' ? 'flex' : 'none'}
              $justify_content={'space-between'}
              $margin={'0 0 12px 0'}
              $align_item={'center'}
            >
              <Div display={'flex'} $gap={'14px'} $align_item={'center'}>
                <NumberMarker markerText={selectPin?.Idx.toString()} />
                <Span option={'small'} color={COLOR.black50}>
                  {setDateFormat('LOCATION_TIME', selectPin.Date as number)}
                </Span>
              </Div>
              <Svg
                name={'xIcon'}
                width={'28px'}
                height={'28px'}
                onClick={() => dispatch(resetSelectPin())}
              />
            </Div>
            <Div display={'flex'} width={'100%'} height={'24px'}>
              <Svg name={locationTypeText[selectPin.Type]?.svgName} $margin={'13px 0'} />
              <Span $margin={'0 14px'} option={'small'} $text_align={'left'}>
                {locationTypeText[selectPin.Type]?.text}
              </Span>
            </Div>
            <Div
              width={'100%'}
              $bgColor={COLOR.black4}
              $min_height={setMediaStyle('74px', '51px', '51px')}
              $padding={setMediaStyle('14px 20px', '14px 20px', '14px 20px')}
              $margin={setMediaStyle('14px 0 12px 0', '8px 0 8px', '8px 0')}
              $border_radius={'12px'}
              $align_item={'center'}
              display={'flex'}
            >
              <Span
                option={'small_bold'}
                ellipsis={'unset'}
                style={{ wordBreak: 'break-all' }}
                $text_align={'left'}
              >
                {selectPin.Address === '' ? 'Unknown' : selectPin.Address}
              </Span>
            </Div>
            <Div
              height={setMediaStyle('170px', '274px', 'auto')}
              display={'flex'}
              $gap={'12px'}
              $margin={'0 auto'}
            >
              {[
                { imgSrc: selectPin.FImage, idx: 'F' },
                { imgSrc: selectPin.BImage, idx: 'B' },
              ].map((element: { imgSrc: string; idx: string }) => (
                <Div
                  key={element.idx}
                  width={'50%'}
                  onClick={() => {
                    if (element.imgSrc !== '') {
                      dispatch(setSelectImage(element.idx))
                      dispatch(setImageDetailFlag(true))
                    }
                  }}
                  className={'location_picture_select'}
                >
                  <Image
                    border_radius={'12px'}
                    $ImgSrc={element.imgSrc}
                    width={setMediaStyle('170px', '274px', `${(windowWidth - 52) / 2}px`)}
                    height={setMediaStyle('170px', '274px', `${(windowWidth - 52) / 2}px`)}
                  />
                  {element.imgSrc !== '' && (
                    <Svg
                      name={'image_scale_icon'}
                      style={{
                        position: 'relative',
                        top: '-22.5px',
                        right: '5.5px',
                        float: 'right',
                        height: '0',
                      }}
                    />
                  )}
                </Div>
              ))}
            </Div>
          </>
        )}
      </>
    )
  }

  const CurrentComponent = () => {
    return (
      <>
        {selectPin && (
          <>
            <Div
              display={currentMedia === 'pc' ? 'flex' : 'none'}
              $justify_content={'space-between'}
              $margin={'0 0 14px 0'}
              $align_item={'center'}
            >
              <Div display={'flex'} $gap={'10px'} $align_item={'center'}>
                <NowMarker />
                <Span option={'small'} color={COLOR.black50} width={'240px'} $text_align={'left'}>
                  {setDateFormat('LOCATION_TIME', selectPin.Date as number)}
                </Span>
              </Div>
              <Svg
                name={'xIcon'}
                width={'28px'}
                height={'28px'}
                onClick={() => dispatch(setSelectPin(null))}
              />
            </Div>
            <Div display={'flex'} width={'100%'} height={'24px'}>
              <Svg name={locationTypeText[selectPin.Type]?.svgName} $margin={'13px 0'} />
              <Span $margin={'0 14px'} option={'small'} $text_align={'left'}>
                Current Location
              </Span>
            </Div>
            <Div
              width={'100%'}
              $bgColor={COLOR.black4}
              $min_height={setMediaStyle('74px', '51px', '51px')}
              $padding={setMediaStyle('14px 20px', '14px 20px', '14px 20px')}
              $margin={setMediaStyle('14px 0 12px 0', '8px 0 8px', '8px 0')}
              $border_radius={'12px'}
            >
              <Span
                option={'small_bold'}
                ellipsis={'unset'}
                style={{ wordBreak: 'break-all' }}
                $text_align={'left'}
              >
                {Address}
              </Span>
            </Div>
          </>
        )}
      </>
    )
  }

  return (
    <Div style={selectPin ? LocationDetailModalWrapStyle : {}}>
      <Div ref={ref} style={selectPin ? LocationDetailModalBoxStyle : {}}>
        {isCurrent ? <CurrentComponent /> : <LocationDetailComponent />}
      </Div>
    </Div>
  )
})
export default LocationDetailModal
